<template>
  <section class="tariff-start">
    <div class="container">
      <div class="promo-block">
        <h3>Начните с Free — обновите, когда будете готовы</h3>
        <p>3 проверки — БЕСПЛАТНО, БЕЗ КАРТЫ</p>
        <button
          class="cta-button"
          data-bs-toggle="modal"
          data-bs-target="#authModal"
        >
          Зарегистрироваться и проверить
        </button>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.tariff-start {
  background: rgba(245, 247, 250, 1);
  padding: 60px 0;
  color: white;
}
.promo-block {
  background: rgba(0, 199, 130, 1);
  color: #fff;
  padding: 30px 24px;
  border-radius: 30px;
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
}
.promo-block h3 {
  margin-bottom: 16px;
  font-size: 40px;
  max-width: 90%;

  @media (max-width: 768px) {
    font-size: 24px;
  }
}
.promo-block p {
  font-size: 30px;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 20px;
  }
}
.cta-button {
  background: #fff;
  color: rgba(0, 199, 130, 1);
  padding: 12px 32px;
  border-radius: 100px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  margin-top: 24px;
}
</style>
